import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function About() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="ABOUT SCHOOL"
          title2=""
          parentTitle="About"
          path="About School"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="row about-grid align-items-stretch">
            {/* Left Content */}
            <div className="col-12 col-xl-8">
              <div className="contact-form-card">
                <h2 className="about-title">ABOUT SCHOOL</h2>

                <div className="about-content-card">
                  <p>
                    Carmel School is a Christian Minority School administered by
                    the sisters of the congregation of the mother of Carmel
                    (C.M.C) an Indian Christian education body of wide and long
                    experience.
                  </p>

                  <p>
                    The congregation was founded in 1866. Its main work is
                    education, aiming at the intellectual, social, economic,
                    moral and spiritual advancement of the people particularly
                    of women and children. This school is situated at
                    Sarangabad, Budge Budge and it comes under the religious
                    jurisdiction of the Roman Catholic Bishop of Baruipur.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-12 col-xl-4">
              <div className="contact-map-card about-image-card">
                <div className="about-image-wrap">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/about.jpg"
                    alt="About School"
                    className="about-main-image img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default About;
